import {useAuth} from "../../hooks/useAuth";
import {useEffect, useState} from "react";
import { useIdleTimer } from 'react-idle-timer';

const TIMER_INTERVAL_MS = 500;
const TIMEOUT_DURATION_MS = 7200000;

const AppLogout = ({children} : any) => {
    const [remainingTime, setRemainingTime] = useState<number>(0);
    const { logout } = useAuth();

    const updateRemainingTime = (getRemainingTime: () => number) => {
        setRemainingTime(Math.ceil(getRemainingTime() / 1000));
    };

    const { getRemainingTime } = useIdleTimer({
        onIdle: logout,
        timeout: TIMEOUT_DURATION_MS,
        crossTab: true,
        leaderElection: true,
        syncTimers: 200
    });

    useEffect(() => {
        const interval = setInterval(() => updateRemainingTime(getRemainingTime), TIMER_INTERVAL_MS);
        return () => clearInterval(interval);
    }, [getRemainingTime]);

    return <>{children}</>;
}

export default AppLogout;